import type { IAuthorizationData } from "@mne-authentication/api";

import { LogClient } from "@mnemonic/logging";

import { updateAuthorizationState } from "../../../utils/authStateUtils/authStateUtils";

/**
 * @param authorization - Authorization data returned after authenticating
 *
 * Saves the authorization data to sessionStorage and redirects user to nextURI
 */

export const redirectWithState = (authorization: IAuthorizationData): void => {
  try {
    if (authorization.authorization) {
      updateAuthorizationState({
        authToken: authorization.authorization,
        expires: authorization.expires ?? Date.now() + 9 * 60 * 1000, // fallback 9 min
      });
    } else LogClient.getInstance().logError("redirectWithState: missing authorization token in payload");

    window.location.replace(authorization.nextURI);
  } catch (e) {
    LogClient.getInstance().logError(e);
    window.location.replace(authorization.nextURI);
  }
};
